
import { OrderData } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { BuyDownloadButtonCSV, BuyDownloadButtonPDF, BuyDownloadPdfTemplateButton, BuyDownloadTags, BuyPdfPreview, BuySupplierPdfPreview } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderBuyLayout/BuyButtons'
import { BuyOrderDuplicateButton } from '../../../../BuyOrderButtons'
import { TableData } from '../../../../../../../../../../baseComponents/TwinTable/types'
import { Fragment, useMemo, useState } from 'react'
import { ButtonPrimary } from '../../../../../../../../../../baseComponents/Button'
import ModalProcessBuyOrder from './ModalProcessBuyOrder'
import { BuyOrderStatusInversed } from '@teinor/erp/types/company/order/buy/buyOrder'
import { ModalOpenedTy } from '../../../../../../../../../../baseComponents/Modal/types'
import { OrderStepButtonsBase, OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import { OrderDivideIntoChaptersButton, OrderProductTypesButton, OrderVariablesButton } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtons'
import { OrderStepButtonsDefaultBaseComponent, OrderStepButtonsNewStyleBaseComponent } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent'

const BuyOrderWaitingResponseStepButtons: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    const { t } = useTwinTranslation()
    const OrderId = data?.header?.id
    return (
        <div className='flex items-center relative gap-5 flex-wrap'>
            <OrderStepButtonsDefaultBaseComponent {...{ data, onSubmit, hookFunction: useBuyOrderWaitingResponseStepButtons, ...rest }} className='mr-8' />
            <BuyOrderProcessingButton title={t('processOrder', 'Procesar pedido')} {...{ OrderId, getCompleteData: onSubmit as any, orderStatus: BuyOrderStatusInversed['accepted'] }} data={data} />
        </div>
    )
}

const useBuyOrderWaitingResponseStepButtons = ({ data, onSubmit, isReadOnly }: OrderStepButtonsBaseComponentProps) => {
    const { t } = useTwinTranslation()
    const name = 'buy_order_waiting_response_step_buttons'
    const Order = data?.header

    const defaultButtons = [{ "id": "previewBuyOrderPDF" }, { "id": "downloadBuy" }, { "id": "duplicateBuyOrder" }]

    const buyOrderDuplicateText = t('duplicateBuyOrder', 'Duplicar pedido de compra')
    const buyOrderDownloadCSVText = t('downloadCsv', 'Descargar csv')
    const buyOrderDownloadTagsText = t('printTags', 'Imprimir etiquetas')
    const buyOrderPreviewPDFText = t('previewPdfTemplate', 'Previsualizar plantilla PDF')
    const buyOrderDownloadPDFTemplateText = t('downloadPdfTemplate', 'Descargar plantilla PDF')
    const buyOrderDownloadPDFText = t('downloadPdf', 'Descargar PDF')
    const buyOrderDivideIntoChaptersText = t('divideIntoChapters', 'Dividir en capítulos')
    const buyOrderVariablesText = t('variables', 'Variables')
    const buyOrderProductTypesText = t('valueProductTypes', 'Valor tipos de producto')
    const buyOrderPreviewSupplierPDFText = t('previewSupplierPDF', 'Previsualizar PDF proveedor')

    const ButtonComponents: OrderStepButtonsBase = useMemo(() => {
        return {
            duplicateBuyOrder: {
                component: BuyOrderDuplicateButton,
                extraProps: {
                    title: buyOrderDuplicateText,
                    id: 'duplicateBuyOrder',
                    allRowData: data,
                    permissionTy: 'buy.order',
                }
            },
            downloadBuyCsv: {
                component: BuyDownloadButtonCSV,
                extraProps: {
                    title: buyOrderDownloadCSVText,
                    id: 'downloadBuyCsv',
                    Order,
                    typeTemplate: 'buyOrder'
                }
            },
            downloadBuyTag: {
                component: BuyDownloadTags,
                extraProps: {
                    title: buyOrderDownloadTagsText,
                    id: 'downloadBuyTag',
                    Order,
                    typeTemplate: 'buyOrder'
                }
            },
            previewBuySupplierPDF: {
                component: BuySupplierPdfPreview,
                showButton: Order.supplierPdf?.length,
                extraProps: {
                    title: buyOrderPreviewSupplierPDFText,
                    id: 'previewBuyOrderPDFSupplier',
                    Order,
                    typeTemplate: 'buyOrder',
                    key: 'previewBuyOrderPDFSupplier'
                }
            },
            previewBuyOrderPDF: {
                component: BuyPdfPreview,
                extraProps: {
                    title: buyOrderPreviewPDFText,
                    id: 'previewBuyOrderPDF',
                    Order,
                    typeTemplate: 'buyOrder',
                    key: 'previewBuyOrderPDF'
                }
            },
            downloadBuyTemplate: {
                component: BuyDownloadPdfTemplateButton,
                extraProps: {
                    title: buyOrderDownloadPDFTemplateText,
                    id: 'downloadBuyTemplate',
                    Order,
                    typeTemplate: 'buyOrder',
                    key: 'downloadBuyPDFTemplate'
                }
            },
            downloadBuy: {
                component: BuyDownloadButtonPDF,
                extraProps: {
                    title: buyOrderDownloadPDFText,
                    id: 'downloadBuy',
                    Order,
                    typeTemplate: 'buyOrder',
                }
            },
            divideIntoChaptersQuote: {
                component: OrderDivideIntoChaptersButton,
                extraProps: {
                    title: buyOrderDivideIntoChaptersText,
                    id: 'divideIntoChaptersQuote',
                    allRowData: data,
                    onSubmit,
                    isReadOnly
                }
            },
            variablesQuote: {
                component: OrderVariablesButton,
                extraProps: {
                    title: buyOrderVariablesText,
                    id: 'variablesQuote',
                    allRowData: data,
                    onSubmit,
                    isReadOnly
                }
            },
            buyProductTypes: {
                component: OrderProductTypesButton,
                extraProps: {
                    title: buyOrderProductTypesText,
                    id: 'buyProductTypes',
                    allRowData: data,
                    onSubmit,
                    isReadOnly,
                }
            },
        }
    }, [Order, buyOrderDivideIntoChaptersText, buyOrderDownloadCSVText, buyOrderDownloadPDFTemplateText, buyOrderDownloadPDFText, buyOrderDownloadTagsText, buyOrderDuplicateText, buyOrderPreviewPDFText, buyOrderVariablesText, data, isReadOnly, onSubmit, buyOrderProductTypesText, buyOrderPreviewSupplierPDFText])

    return { name, ButtonComponents, defaultButtons }
}

export const BuyOrderWaitingResponseStepButtonsNew: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    const { t } = useTwinTranslation()
    const OrderId = data?.header?.id
    return (
        <div className='flex order_config_buttons_parent items-center relative gap-5 flex-wrap'>
            <OrderStepButtonsNewStyleBaseComponent {...{ data, onSubmit, hookFunction: useBuyOrderWaitingResponseStepButtons, ...rest }} className='mr-8' />
            <BuyOrderProcessingButton title={t('processOrder', 'Procesar pedido')} {...{ OrderId, getCompleteData: onSubmit as any, orderStatus: BuyOrderStatusInversed['accepted'] }} data={data} />
        </div>
    )
}

interface BuyOrderProcessingButtonProps {
    title: string
    children?: React.ReactNode
    data: OrderData
    getCompleteData: (inputtable?: TableData) => Promise<void>
}

const BuyOrderProcessingButton: React.FC<BuyOrderProcessingButtonProps> = ({ title, data, getCompleteData }) => {
    const [opened, setOpened] = useState<ModalOpenedTy>(null)
    return (
        <Fragment>
            <ButtonPrimary id={'buyOrder' + data?.header?.id} onClick={() => setOpened(true)}>{title}</ButtonPrimary>
            {opened ? <ModalProcessBuyOrder setOpened={setOpened} data={data} getCompleteData={getCompleteData} /> : null}
        </Fragment>
    )
}


export default BuyOrderWaitingResponseStepButtons